// frontend/src/stores/syncStore.js
// Implementado con Vue.observable (Vue 2 compatible) en lugar de Pinia
import { getPendingCount, networkState, syncQueue } from "@/services/offlineService";
import Vue from "vue";

// ─────────────────────────────────────────────
// ESTADO REACTIVO
// ─────────────────────────────────────────────
export const syncState = Vue.observable({
  pendingCount: 0,
  isSyncing: false,
  lastSyncAt: null,
  syncError: null,
});

// ─────────────────────────────────────────────
// ACCIONES
// ─────────────────────────────────────────────

/**
 * Refresca el contador de operaciones pendientes desde la cola.
 */
export async function refreshPendingCount() {
  syncState.pendingCount = await getPendingCount();
}

/**
 * Fuerza la sincronización de la cola con el servidor.
 * @returns {{ synced: number, failed: number } | undefined}
 */
export async function forceSync() {
  if (!networkState.isOnline) {
    syncState.syncError = "No hay conexión a internet";
    return;
  }
  syncState.isSyncing = true;
  syncState.syncError = null;
  try {
    const result = await syncQueue();
    syncState.lastSyncAt = new Date().toISOString();
    await refreshPendingCount();
    return result;
  } catch (err) {
    syncState.syncError = "Error durante la sincronización";
  } finally {
    syncState.isSyncing = false;
  }
}
